// Social platforms an empresa can link to. Stored under
// empresa.additional_attributes.social_profiles[key] (mirrors contacts).
export const EMPRESA_SOCIAL_PLATFORMS = [
  {
    key: 'linkedin',
    label: 'LinkedIn',
    icon: 'i-ri-linkedin-box-fill',
    prefix: 'https://linkedin.com/company/',
  },
  {
    key: 'twitter',
    label: 'X (Twitter)',
    icon: 'i-ri-twitter-x-fill',
    prefix: 'https://x.com/',
  },
  {
    key: 'facebook',
    label: 'Facebook',
    icon: 'i-ri-facebook-circle-fill',
    prefix: 'https://facebook.com/',
  },
  {
    key: 'instagram',
    label: 'Instagram',
    icon: 'i-ri-instagram-line',
    prefix: 'https://instagram.com/',
  },
  {
    key: 'github',
    label: 'GitHub',
    icon: 'i-ri-github-fill',
    prefix: 'https://github.com/',
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    icon: 'i-ri-tiktok-fill',
    prefix: 'https://tiktok.com/@',
  },
];
